<template>
  <div class="towercrane" id="container">
    <div class="towercrane-container">
      <div class="towercrane_bg" v-if="project_id== '1196'"></div>
      <div
        style="background: #31334a; border: #3a3b5a 2px solid; font-size: 32px; color: white; width: 540px; height: 60px; line-height: 60px; margin-top: 10px; margin-left: 10px; font-family:Probert">
        {{ project_name }}
      </div>
      <div
        style="color: white; font-size: 16px; margin-left: 10px; margin-top: 8px; font-weight: bold; width: 300px; text-align: left">
        NO. OF ALERT
      </div>
      <!--TOTAL NO. OF ALARM-->
      <div style="margin-top: 8px; margin-left: 10px; height: 60px">
        <div v-for="num in analyzeAlarmNo(alarm_no)"
             style="position: relative; width: 50px; height: 60px; line-height: 60px; background: #283C71; color: white; font-size: 36px; margin-right: 5px; float: left; font-family: MetroDF">
          {{ num }}
        </div>
        <div
          style="display: inline-block; position: relative; width: 100px; height: 60px; float: left; left: 20px; text-align: left">
          <div style="color: white; height: 20px; line-height: 20px; font-size: 12px">Unresolved</div>
          <div style="color: #C4327A; height: 45px; line-height: 45px; font-size: 24px">{{ untreated_no }}</div>
        </div>
        <div
          style="display: inline-block; position: relative; width: 100px; height: 60px; float: left; left: 20px; text-align: left">
          <div style="color: white; height: 20px; line-height: 20px; font-size: 12px">Resolved</div>
          <div style="color: #4B61C5; height: 45px; line-height: 45px; font-size: 24px">{{ resolved_no }}</div>
        </div>
        <div
          style="display: inline-block; position: relative; width: 120px; height: 60px; float: left; left: 20px; text-align: left">
          <div style="color: white; height: 20px; line-height: 20px; font-size: 12px">Rate</div>
          <div style="color: #4B61C5; height: 45px; line-height: 45px; font-size: 24px">
            {{ Math.round(resolved_no / alarm_no * 10000) / 100.00 + '%' }}
          </div>
        </div>
      </div>
      <!--STAFF OF VIOLATION-->
      <div
        style="background: #31334a; width: 390px; height: 800px; margin-left: 10px; margin-top: 8px; font-size: 12px; color: white; text-align: left; border: #3a3b5a 2px solid; padding: 5px">
        Information
        <el-table
          :header-cell-style="{color:'white', borderColor: 'transparent', background: 'transparent', textAlign: 'left', fontSize: '16px'}"
          :cell-style="cellStyle"
          :row-style="{background:'transparent', height: '16px', fontSize: '12px'}"
          :header-row-style="{background: 'transparent',}"
          :data="tcmsg"
          height="800"
          style="width: 100%; margin-top: 5px">
          <el-table-column
            prop="tcname"
            align="center"
            label="T.Crane"
            :show-overflow-tooltip="true"
            width="90">
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="Operator"
            :show-overflow-tooltip="true"
            width="120">
          </el-table-column>
          <el-table-column
            prop="license"
            align="center"
            width="120"
            :show-overflow-tooltip="true"
            label="License">
          </el-table-column>
          <el-table-column
            prop="zone"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
            label="Zone">
          </el-table-column>
        </el-table>
        <div></div>
      </div>
      <!--cameras-->
      <div
        style="position: absolute; right: 10px; top: 10px; width: 300px; height: 250px; font-size: 12px; border: #3a3b5a 2px solid">
        <el-radio-group v-model="radio1"
                        @change="cameraChange"
                        style="width: 300px">
          <el-radio-button class="leftCamera" label="CAM1"></el-radio-button>
          <el-radio-button class="leftCamera" label="CAM2"></el-radio-button>
          <el-radio-button class="leftCamera" label="CAM3"></el-radio-button>
          <el-radio-button class="rightCamera" label="CAM4"></el-radio-button>
        </el-radio-group>

        <div style="width: 286px; height: 212px; background: #a7a7a7; margin: 6px">
          <video id="myPlayer1" style="width:100%; height: 100%; font-size: 10px; border:1px solid whitesmoke"
                 ref='video1' controls playsInline
                 webkit-playsinline
                 autoplay>
          </video>
        </div>

      </div>
      <!--PROGRESS INFORMATION-->
      <div
        style="position: absolute; right: 10px; top: 270px; width: 290px; height: 380px; background: #31334a; font-size: 12px; border: #3a3b5a 2px solid; text-align: left; color: white; padding: 5px">
        Progress
        <div style="width: 280px; height: 220px; padding: 5px; overflow: auto">
          <div v-for="item in progresses">
            {{ item.blk_name }}
            <el-progress :percentage="item.progress"></el-progress>
          </div>
        </div>
        <div style="width: 100%; height: 90px; margin-top: 25px; padding: 0 10%">
          <div style="width: 40%; height: 100%; float: left; text-align: left">
            Time Used
            <el-progress type="circle" :width="75" :percentage="utime" style="margin: 10px 10px"></el-progress>
          </div>
          <div style="width: 40%; height: 100%; float: left">
            Monthly Progress
            <el-progress type="circle" :width="75" :percentage="uprogress" style="margin: 10px 15px"></el-progress>
          </div>
        </div>
      </div>
      <div class="image_circle" v-if="project_id == '1196'">
        <!--<div class="smalldiv" style="left: 856px; top: 542px"></div>-->
        <div class="father">
          <div class="mask" v-show="maskShow" @click="setMaskShow"></div>
          <div class="circle" style="left: 784px; top: 469px" ref="circle1" @click="setMaskShow(1)">
            <div class="line">
              <hr class="cline"/>
            </div>
          </div>
          <detail :rundata="rundata" class="child" id="child" v-show="maskShow"></detail>
          <div class="close" v-show="maskShow" @click="setMaskShow(0)">close</div>
        </div>
        <!--<div class="smalldiv" style="left: 756px; top: 506px"></div>-->
        <div class="circle" style="left: 684px; top: 433px" ref="circle2" @click="setMaskShow(2)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
        <!--<div class="smalldiv" style="left: 648px; top: 470px"></div>-->
        <div class="circle" style="left: 576px; top: 397px" ref="circle3" @click="setMaskShow(3)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
        <!--<div class="smalldiv" style="left: 550px; top: 415px"></div>-->
        <div class="circle" style="left: 478px; top: 342px" ref="circle4" @click="setMaskShow(4)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
        <!--<div class="smalldiv" style="left: 517px;top: 300px"></div>-->
        <div class="circle" style="left: 445px; top: 227px" ref="circle5" @click="setMaskShow(5)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>

        <!--<div class="smalldiv" style="left: 520px; top: 215px"></div>-->
        <div class="circle" style="left: 448px; top: 142px" ref="circle6" @click="setMaskShow(6)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
        <!--<div class="smalldiv" style="left: 664px; top: 250px"></div>-->
        <div class="circle" style="left: 592px; top: 177px" ref="circle7" @click="setMaskShow(7)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
        <!--<div class="smalldiv" style="left: 788px; top: 285px"></div>-->
        <div class="circle" style="left: 716px; top: 212px" ref="circle8" @click="setMaskShow(8)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
        <!--<div class="smalldiv" style="right: 442px; top: 400px;"></div>-->
        <div class="circle" style="right: 372px; top: 327px" ref="circle9" @click="setMaskShow(9)">
          <div class="line">
            <hr class="cline"/>
          </div>
        </div>
      </div>
      <div v-else>
        No TowerCrane Data
      </div>
    </div>
  </div>
</template>

<script>
import detail from '@/components/towercrane/detail'
import axios from 'axios'
import {EZUIKit} from '../../../static/js/ezuikit'

export default {
  name: "towercrane",
  props: ['project_id', 'project_name'],

  data: function () {
    return {
      maskShow: false,
      server: "wss://shell.cmstech.sg/wss/chat?tid=269&pid=200031",
      cctv_url1: '',
      cctv_url2: '',
      cctv_url3: '',
      cctv_url4: '',
      socket: "",
      rundata: {},
      board_name: 'Normenton Park Dashboard',
      alarm_no: 0,
      untreated_no: 0,
      resolved_no: 0,
      utime: 0,
      uprogress: 0,
      radio1: 'Camera1',
      camera: 'Camera1',
      player1: null,
      tcmsg: [],
      progresses: []
    }
  },
  methods: {
    init: function () {
      if (this.project_id != '1196') {
        return
      }
      this.progresses = [
        {blk_name: 'BLK 1', progress: 0},
        {blk_name: 'BLK 2', progress: 100},
        {blk_name: 'BLK 3', progress: 40},
        {blk_name: 'BLK 4', progress: 38},
        {blk_name: 'BLK 5', progress: 42},
        {blk_name: 'BLK 6', progress: 71},
        {blk_name: 'BLK 7', progress: 68},
        {blk_name: 'BLK 8', progress: 73},
        {blk_name: 'BLK 9', progress: 71},
      ]
      this.alarm_no = 62
      this.untreated_no = 19
      this.resolved_no = 43
      this.utime = 26
      this.uprogress = 70
      this.cctv_url1 = 'http://203.125.12.206:9080/hls/t311d5.m3u8?proto=https'
      this.cctv_url2 = 'http://203.125.12.206:9080/hls/t311d4.m3u8?proto=https'
      this.cctv_url3 = 'http://203.125.12.206:9080/hls/t311d3.m3u8?proto=https'
      this.cctv_url4 = 'http://203.125.12.206:9080/hls/t311d2.m3u8?proto=https'
      let postData = {host: "CSD", token: "lalala"}
      axios.post(this.$store.getters.getCmsDBServer + "CMSGetTCOperator", postData).then(response => {
        let errNo = response.data.errno
        let errStr = response.data.errstr
        if (errNo == "0") {
          this.tcmsg = response.data.result.slice(0, 12)
        }
      }).catch(error => {
        alert(error)
      })
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.server)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
      this.$refs.video1.src = this.cctv_url1
      this.player1 = new EZUIKit.EZUIPlayer('myPlayer1');

    },
    cellStyle: function ({row, column, rowIndex, columnIndex}) {
      if ((rowIndex % 2) == 1) {
        return "background:transparent; color:#fff; borderColor: transparent; textAlign: left; padding: 5px 0"
      } else {
        return "background:#344477; color:#fff; borderColor: transparent; textAlign: left; padding: 2px 0"
      }
    },
    cameraChange: function (val) {
      if (val == 'Camera1') {
        this.player1.stop()
        this.$refs.video1.src = this.cctv_url1
        this.player1 = new EZUIKit.EZUIPlayer('myPlayer1');
      } else if (val == 'Camera2') {
        this.player1.stop()
        this.$refs.video1.src = this.cctv_url2
        this.player1 = new EZUIKit.EZUIPlayer('myPlayer1');
      } else if (val == 'Camera3') {
        this.player1.stop()
        this.$refs.video1.src = this.cctv_url3
        this.player1 = new EZUIKit.EZUIPlayer('myPlayer1');
      } else {
        this.player1.stop()
        this.$refs.video1.src = this.cctv_url4
        this.player1 = new EZUIKit.EZUIPlayer('myPlayer1');
      }
    },
    open: function () {
      console.log("socket连接成功")
    },
    error: function () {
      console.log("连接错误")
    },
    analyzeAlarmNo: function (alarm_no) {
      var nos = []
      var noStr = alarm_no.toString()
      nos = noStr.split('')
      if (noStr.length == 1) {
        nos.splice(0, 0, '0', '0')
      } else if (noStr.length == 2) {
        nos.splice(0, 0, '0')
      }
      return nos
    },
    getMessage: function (msg) {
      if (msg.data && msg.data != '') {
        this.rundata = JSON.parse(msg.data)
        console.log(this.rundata)
        // console.log("get data from server Angle:" + this.rundata.rotationAngle)
        if (this.rundata.rotationAngle >= '0') {
          this.rotate('circle9', this.rundata.rotationAngle);
        }
      }
    },
    send: function () {
      this.socket.send(params)
    },
    close: function () {
      console.log("socket已经关闭")
    },
    setMaskShow(id) {
      if (id === 9 || id === 0) {
        this.maskShow = !this.maskShow;
      }
    },
    rotate(refid, angle) {
      if (refid == 'circle9') {
        this.$refs.circle9.style.transform = 'rotate(' + angle + 'deg)';
      } else if (refid == 'circle2') {
        this.$refs.circle2.style.transform = 'rotate(' + angle + 'deg)';
      }
    },
    setRotate() {
      console.log("in setcrotate");
      this.rotate('circle1', '30');
    },
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
    }
  },
  components: {
    detail
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>


@font-face {
  font-family MetroDF
  src url("../../../static/fonts/MetroDF.ttf")
}

@font-face {
  font-family Probert
  src url("../../../static/fonts/ProbertBold.ttf")
}

.smalldiv {
  position: absolute;
  z-index: 50;
  width: 4px;
  height: 4px;
  background-color: white;
}

.circle {
  position: absolute;
  z-index: 50;
  transition: all 5s ease-in-out 0s;
  width: 140px;
  height: 140px;
  border: 5px solid #7e8bad;
  border-radius: 50%;
  background-color: #272B43;
  opacity: 0.3;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg); /* Safari �� Chrome */
}

.cline {
  height: 2px;
  background: #7e8bad;
}

.line {
  margin-top: 70px;
  margin-left: 70px;
  width: 70px;
}

.towercrane {
  width: 100%
  height: 100%
  position: relative;
  margin: 0;
  padding: 0;
}

.towercrane-container {
  position: relative;
  width: 100%
  height: 100%
  margin: 0;
  padding: 0;
  overflow: hidden
}

.towercrane_bg {
  position absolute
  width 85%
  height 90%
  top 10%
  right 0
  background url("../../assets/towercrane_bg.png") no-repeat center center
  background-size contain
}

//设置表格的外边框
.el-table::before {
  background-color transparent
}

.el-table::after {
  background-color transparent
}

//设置表格的背景颜色
.el-table,
.el-table__expanded-cell {
  background-color: transparent;
}

//鼠标悬浮  >>>穿透stylus的样式
>>> .el-table tbody tr:hover > td {
  background-color: #6CF !important
}

.el-radio-button /deep/
color white
  &.leftCamera {
    margin-right 4px
  }

  &.rightCamera {
    margin-right 0
  }

  .el-radio-button__inner
    background transparent
    border-radius 0
    font-size 12px
    color white
    border #4765E6 1px solid
    width 72px
    padding 6px 8px

.el-radio-button.is-active /deep/
.el-radio-button__inner
  background #4765E6

>>> .el-progress__text {
  color white
  font-size 12px
}

>>> .el-progress-bar__outer
  border-radius 0

>>> .el-progress-bar__inner
  border-radius 0

.image_circle {
  width: 78%
  float left
}

.close {
  width: 70px;
  height: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  background: #009393;
  color: white;
  position: absolute;
  right: 60px;
  top: 17px;
  z-index: 100;
}

.father {
  width: 100%;
  height: 100%;
}

.mask {
  position: absolute;
  right: 370px;
  top: 143px;
  z-index: 50;
  width: 150px;
  height: 150px;
  border: 2px solid #7e8bad;
  border-radius: 50%;
  background-color: #272B43;
  opacity: 0.3;

}

.child {
  position: absolute;
  right: 50px;
  top: 10px;
  z-index: 100;
  width: 95%;
  height: 98%;
  border: 1px solid #009393;
  background: #24293c;
  opacity: 0.96;
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/towercrane/towercrane.vue